import { render, staticRenderFns } from "./MasterTripDistance.vue?vue&type=template&id=08601527&scoped=true"
import script from "./MasterTripDistance.vue?vue&type=script&lang=js"
export * from "./MasterTripDistance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08601527",
  null
  
)

export default component.exports